import { render, staticRenderFns } from "./CartaoListaDeJobs.vue?vue&type=template&id=6833b8aa&scoped=true"
import script from "./CartaoListaDeJobs.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoListaDeJobs.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoListaDeJobs.vue?vue&type=style&index=0&id=6833b8aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6833b8aa",
  null
  
)

export default component.exports